var map = {
	"./aboutus_bg.png": "9735",
	"./aboutus_ceftification.png": "c9cc",
	"./aboutus_fd.png": "f6a9",
	"./home_phone.png": "9673",
	"./home_wechat.png": "3b58",
	"./images_marketing_bg1.png": "299e",
	"./images_marketing_bg2.png": "d094",
	"./images_marketing_bg3.png": "fbf3",
	"./images_project_bg1.png": "a2be",
	"./images_project_bg2.png": "852a",
	"./images_project_bg3.png": "3ae2",
	"./logo.png": "4e6a",
	"./magnifyBusinessLicense.png": "feb7",
	"./qrcode_1.png": "1619",
	"./qrcode_2.png": "cc88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60c3";